import React, {Component}  from "react"
import {requestDiscPackages, addItemToDisc, addItemsToDisc,addDiscToDisc} from "../../actions/disc-actions";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Dialog} from "../../../common/components/dialog"
import AlertDialog from "../../../common/components/alert-dialog"
import DiscProjectEditDialog from './disc-project-edit-dialog';
import "../../style/disc-dialog.scss"

class AddToDiscDialog extends Component{
    constructor(props){
        super(props)
        this.onDiscSelected = this.onDiscSelected.bind(this)
        this.addDisc = this.addDisc.bind(this)
        this.onCreateDialogClose = this.onCreateDialogClose.bind(this)
        this.fetchMoreDiscs = this.fetchMoreDiscs.bind(this)
        this.state = {
            isCreateDialogOpen: false,
            isProcessing: false
        }
    }

    componentWillMount(){


    }
    componentDidMount(){
        this._isMounted = true;
        this.fetchMoreDiscs()
    }
    componentWillUnmount(){
        this._isMounted = false;
    }
    fetchMoreDiscs(){
        if(this.props.disc.offset != this.props.disc.count || this.props.disc.discPackages.length == 0){
            if(!this.props.disc.amIFetching){
                console.log("Requesting disc offset " + this.props.disc.offset);
                this.props.requestDiscPackages(this.props.disc.offset,10);
            }
            console.log("Setting timer to fetch more discs");
            setTimeout(()=> this.fetchMoreDiscs(), 1000);
        }
    }
    componentWillReceiveProps(nextProps){
        if(nextProps.disc.saveSuccessful && nextProps.disc.discUpdated != null && nextProps.disc.discPackages.length != this.props.disc.discPackages.length && this.state.isProcessing){
            this.setState({isProcessing:false})
            this.onDiscSelected(nextProps.disc.discUpdated);
        }
        if(!nextProps.disc.saveSuccessful && nextProps.disc.errorMessage){
            //show the error
        }
    }
    onDiscSelected(disc){
        this.setState({isProcessing: true,discPackageId: disc.id})
        if(this.props.customCollectionElements){
            let itemArray = this.props.customCollectionElements.map(item=>item.id);
            this.props.addItemsToDisc(
                itemArray,
                "cces",
                disc.id,
                disc.discPackageType,
                (resp) => {
                    if(resp.status === "FAILED"){
                        this.setState({isProcessing:false,errorMessage: "Unable to add items to disc: " +resp.errorMessage})
                    }else{
                        this.props.onClose();
                    }
                }
            )
        }else if(this.props.fromDisc){
            this.props.addDiscToDisc(disc.id,this.props.fromDisc.id, disc.discPackageType,
                (resp) => {
                    if(resp.status === "FAILED"){
                        this.setState({isProcessing:false,errorMessage: "Unable to add items to disc: " +resp.errorMessage})
                    }else{
                        this.props.onClose();

                    }
                });
        }else {
            this.props.addItemToDisc(
                this.props.album.id,
                "cc",
                disc.id,
                disc.discPackageType,
                (resp) => {
                    if(resp.status === "FAILED"){
                        this.setState({isProcessing:false,errorMessage: "Unable to add items to disc: " +resp.errorMessage})
                    }else{
                        this.props.onClose();
                    }
                }
            )
        }

    }
    addDisc(){
        this.setState({isCreateDialogOpen:true,isProcessing:true})
    }
    onCreateDialogClose(){
        if(this._isMounted) {
            this.setState({isCreateDialogOpen: false,isProcessing:false})
        }
    }
    hasPhotos(album, customCollectionElements,fromDisc){
        if(album && album.stats.numPhotos > 0){
            return true;
        }
        if(customCollectionElements){
            for(let i=0;i<customCollectionElements.length; i++){
                if(customCollectionElements[i].elementType === "photo"){
                    return true;
                }
            }
        }
        if(fromDisc){
            return fromDisc.discPackageType == "PhotoCdPackage";
        }
        return false;
    }
    hasVideos(album, customCollectionElements,fromDisc){
        if(album && album.stats.numClips > 0){
            return true;
        }
        if(customCollectionElements){
            for(let i=0;i<customCollectionElements.length; i++){
                if(customCollectionElements[i].elementType === "video"){
                    return true;
                }
            }
        }
        if(fromDisc){
            return fromDisc.discPackageType != "PhotoCdPackage";
        }
        return false;
    }
    render(){
        const hasPhotos = this.hasPhotos(this.props.album, this.props.customCollectionElements, this.props.fromDisc)
        const hasVideos = this.hasVideos(this.props.album, this.props.customCollectionElements, this.props.fromDisc)
        if(!this.props.disc.discPackages || !this.props.isOpen ){
            return <div/>
        }
        if(!(hasPhotos || hasVideos)) {
            if (this.props.album && this.props.album.stats.numElements === 0) {
                return (
                    <AlertDialog title="Add To Disc" message="You can not add an empty album to a disc"
                                 isOpen={this.props.isOpen}
                                 onOkAction={this.props.onClose}/>
                )
            }
            else{
                return (
                    <AlertDialog title="Add To Disc" message="Please select some media first"
                                 isOpen={this.props.isOpen}
                                 onOkAction={this.props.onClose}/>
                )
            }
        }

        const filteredDiscList = [...this.props.disc.discPackages.values()]
            .filter(item=>item.finalizedYn==="N" &&
                ((hasVideos ? item.discPackageType ==="DvdPackage":false)
                    || (hasPhotos ? item.discPackageType === "PhotoCdPackage":false)))

        let discPackageType = "any";
        let filterNotice = "";
        if(!hasVideos){
            filterNotice = "Your in-progress discs capable of holding photos"
            discPackageType = "PhotoCdPackage"
        }
        if(!hasPhotos){
            filterNotice = "Your in-progress discs capable of holding videos"
            discPackageType = "DvdPackage"
        }
        const isIncomplete = this.props.disc.amIFetching || this.props.disc.offset != this.props.disc.count;


        return (
            <Dialog className="add-disc-dialog" title={this.props.disc.isProcessing?"Processing ...":"Add To Disc"} canCancel={true} isOpen={this.props.isOpen} onClose={this.props.onClose}>
                <React.Fragment>
                    <div className="add-to-disc-content">
                        { this.state.errorMessage ? <div className="alert alert-failed">{this.state.errorMessage}</div>:""}
                        <div className="new-disc" onClick={this.addDisc}>
                            <img src={require("../../images/new-disc.png")} width="50" height="50" alt="Add Disc"/>
                            <span>New Disc</span>
                        </div>
                        <div className="add-to-disc-line"></div>
                        <div className="existing-disc-list">
                            {isIncomplete &&
                                <div className="disc-list-notice"><i>Fetching discs {this.props.disc.count == 0?"": this.props.disc.offset+" of " + this.props.disc.count}</i></div>
                            }

                            {filteredDiscList.map(item => {
                                return (
                                    <DiscItem key={item.id} discPackage={item} onClick={() => this.onDiscSelected(item)}/>
                                )
                            })}
                        </div>

                    </div>
                    <DiscProjectEditDialog isOpen={this.state.isCreateDialogOpen} onClose={this.onCreateDialogClose} discPackageType={discPackageType}/>

                </React.Fragment>
            </Dialog>
        )
    }
}
const DiscItem = (props) => {
    const {discPackage} = props;
    const imgSrc = (typeof(discPackage.thumbnails) === "undefined" || discPackage.thumbnails.length === 0) ?
        require("../../../common/images/icon-missing-asset-grey.svg"):
        discPackage.thumbnails[Math.min(discPackage.thumbnails.length - 1, 0)]
    return (
        <div className="disc-mini-item" onClick={props.onClick}>
            <div className="disc-mini-thumb-container">
                <img width="60" src={imgSrc} alt="Disc Thumb" className="disc-mini-image"/>
                <img width="61" src={require("../../images/disc-cover-dialog.png")} className="disc-mini-overlay" alt="disc overlay"/>
            </div>
            <div className="disc-mini-description">
                <h3>{discPackage.caseTitle}</h3>
                {discPackage.numItems} {discPackage.discPackageType === "PhotoCdPackage" ? "Photos":"Videos"}
            </div>

        </div>
    )
}
AddToDiscDialog.propTypes = {
    requestDiscPackages: PropTypes.func.isRequired,
    disc: PropTypes.object.isRequired,
    album: PropTypes.object,
    customCollectionElements: PropTypes.array,
    fromDisc: PropTypes.object
};

const mapStateToProps = state => {
    return {
        disc: state.disc
    };
};

const mapDispatchToProps = (dispatch, offset) => {
    return {
        requestDiscPackages: (offset,max) => dispatch(requestDiscPackages(dispatch, offset,max)),
        addItemToDisc: (itemId, itemType, discId, discPackageType,callback) => addItemToDisc(dispatch, itemId, itemType, discId, discPackageType,callback),
        addItemsToDisc: (itemArray, itemType, discId, discPackageType,callback) => addItemsToDisc(dispatch, itemArray, itemType, discId, discPackageType,callback),
        addDiscToDisc: (toDiscId, fromDiscId, discPackageType, callback) => addDiscToDisc(dispatch,toDiscId, fromDiscId, discPackageType, callback)
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddToDiscDialog);



// WEBPACK FOOTER //
// ./src/disc/components/dialog/add-to-disc-dialog.jsx